<div [id]="mapId" [style.width]="width" [style.height]="height"></div>
<!--div *ngIf="segment?.elevation_profile" class="elevation" [style.backgroundImage]="'url('+segment.elevation_profile+')'"></div-->
